import React from "react"
import { Container, Row, Col, Carousel } from "react-bootstrap"
import roadmap from "../assets/images/roadmap.png"
import roadmapmob from "../assets/images/roadmap-line-mobile.png"
import { graphql, useStaticQuery } from "gatsby"

const Roadmap = () => {
  const query = graphql`
    {
      strapiHomePage {
        roadmap_heading
        roadmap1_heading
        roadmap1_points {
          id
          points
        }
        roadmap2_heading
        roadmap2_points {
          id
          points
        }
        roadmap3_heading
        roadmap3_points {
          id
          points
        }
      }
    }
  `

  const data = useStaticQuery(query)

  const {
    strapiHomePage: {
      roadmap_heading,
      roadmap1_heading,
      roadmap1_points,
      roadmap2_heading,
      roadmap2_points,
      roadmap3_heading,
      roadmap3_points,
    },
  } = data

  return (
    <>
      <Container className="roadmap d-none d-lg-block">
        <h1 className="text-center">{roadmap_heading}</h1>
        <Row className="justify-content-center my-4">
          <Col lg={4}>
            <p className="text-center">{roadmap1_heading}</p>
          </Col>
          <Col lg={4}>
            <p className="text-center">{roadmap2_heading}</p>
          </Col>
          <Col lg={4}>
            <p className="text-center">{roadmap3_heading}</p>
          </Col>
          <img src={roadmap} alt="" />
        </Row>
        <Row className="justify-content-center my-4">
          <Col lg={4}>
            <ul>
              {roadmap1_points.map(item => {
                return <li key={item.id}>{item.points}</li>
              })}
            </ul>
          </Col>
          <Col lg={4}>
            <ul>
              {roadmap2_points.map(item => {
                return <li key={item.id}>{item.points}</li>
              })}
            </ul>
          </Col>
          <Col lg={4}>
            <ul>
              {roadmap3_points.map(item => {
                return <li key={item.id}>{item.points}</li>
              })}
            </ul>
          </Col>
        </Row>
      </Container>

      <Container className="roadmap d-lg-none d-block">
        <h1 className="text-center">{roadmap_heading}</h1>
        <Carousel>
          <Carousel.Item>
            <p className="text-center">{roadmap1_heading}</p>
            <div className="d-flex justify-content-center">
              <img src={roadmapmob} alt="" />
            </div>
            <ul className="my-4">
              <li>{roadmap1_points[0].points}</li>
              <li>{roadmap1_points[1].points}</li>
              <li>{roadmap1_points[2].points}</li>
            </ul>
          </Carousel.Item>
          <Carousel.Item>
            <p className="text-center">{roadmap2_heading}</p>
            <div className="d-flex justify-content-center">
              <img src={roadmapmob} alt="" />
            </div>
            <ul className="my-4">
              <li>{roadmap2_points[0].points}</li>
              <li>{roadmap2_points[1].points}</li>
              <li>{roadmap2_points[2].points}</li>
            </ul>
          </Carousel.Item>
          <Carousel.Item>
            <p className="text-center">{roadmap3_heading}</p>
            <div className="d-flex justify-content-center">
              <img src={roadmapmob} alt="" />
            </div>
            <ul className="my-4">
              <li>{roadmap3_points[0].points}</li>
              <li>{roadmap3_points[1].points}</li>
              <li>{roadmap3_points[2].points}</li>
            </ul>
          </Carousel.Item>
        </Carousel>
      </Container>
    </>
  )
}

export default Roadmap
